import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import * as R from 'remeda'

import { findByPath, nineNumbers, pathOr } from '~/utils'

import { useSampleSize } from '../../hooks/useSampleSize'
import { type InputValues } from '../../utils'

import { type TabulationQueryResult } from './useTabulationQuery'
import { useTabulationQueryKey } from './useTabulationQueryKey'

export const useTabulationData = () => {
  const queryKey = useTabulationQueryKey()
  const { data } = useQuery<TabulationQueryResult>({
    enabled: false,
    queryKey,
  })
  const { watch } = useFormContext<InputValues>()
  const brandId = watch('brandId')
  const sampleSize = useSampleSize()

  return React.useMemo(
    () =>
      nineNumbers.map((nineNumber) => {
        const count = R.pipe(
          data ?? [],
          findByPath('id', brandId),
          pathOr('result', []),
          findByPath('segmentNumber', nineNumber),
          pathOr('count', NaN),
        )
        const ratio = count / sampleSize

        return { nineNumber, count, ratio }
      }),
    [brandId, data, sampleSize],
  )
}
